import Environment from '@interfaces/environment.interface'
import Notification, { PushNotificationInfos } from '@interfaces/notification.interface'
import onEnvironmentChange from '@observables/environment.observable'
import LogService from '@services/log/log.service'
import MainService from '@services/main/main.service'
import { AxiosResponse } from 'axios'
import { take } from 'rxjs/operators'

export default class AlfredService extends MainService {
  url: string
  logService = new LogService()

  constructor(alfredUrl?: string) {
    super()
    if (!alfredUrl) {
      onEnvironmentChange.pipe(take(1)).subscribe((environment: Environment) => {
        this.url = environment?.squidApis?.alfred
      })
    } else {
      this.url = alfredUrl
    }
    this.logService.init('alfredUrl Service')
  }

  public async getCountNotifications(): Promise<{
    sent: number
    seen: number
    read: number
  }> {
    const headers = await this.getHeaders()
    return this.http
      .get(`${this.url}/hub/notifications/status`, { headers })
      .then((r: AxiosResponse) => r.data)
      .catch((error: any) => {
        this.logService.error({
          message: 'Error on get notifications count',
          error,
        })
        throw error.response
      })
  }

  public async getNotifications(page = 1, limit = 100): Promise<Array<Notification>> {
    const headers = await this.getHeaders()
    return this.http
      .get(`${this.url}/hub/notifications?limit=${limit}&page=${page}`, { headers })
      .then((r: AxiosResponse) => r.data)
      .catch((error: any) => {
        this.logService.error({
          message: 'Error on get notifications',
          error,
        })
        throw error.response
      })
  }

  public async updateNotificationsStatus(notifications: Array<string>, status: 'sent' | 'seen' | 'read') {
    if (!notifications || notifications.length < 1) {
      throw new Error('Must contain a valid notification')
    }

    if (!status) {
      throw new Error('Must contain a valid status')
    }
    const headers = await this.getHeaders()
    return this.http
      .put(`${this.url}/hub/notifications/status/${status}`, [...notifications], { headers })
      .then((r: AxiosResponse) => r.data)
      .catch((error: any) => {
        this.logService.error({
          message: 'Error on update notifications',
          error,
        })
        throw error.response
      })
  }

  public async sendNotificationsInfo({ squidId, email, deviceId, type, system, token }: PushNotificationInfos): Promise<any> {
    if (!squidId) {
      throw new Error('Must contain a squidId')
    }
    if (!email) {
      throw new Error('Must contain a email')
    }
    if (!deviceId) {
      throw new Error('Must contain a deviceId')
    }
    if (!type) {
      throw new Error('Must contain a type')
    }
    if (!system) {
      throw new Error('Must contain a system')
    }
    if (!token) {
      throw new Error('Must contain a token')
    }

    const headers = await this.getHeaders()

    if (!headers) {
      throw new Error('Error on get headers')
    }

    return this.http
      .post(`${this.url}/hub/push/allow-notify`, { squidId, email, deviceId, type, system, token }, { headers })
      .then((r: AxiosResponse) => r.data)
      .catch((error: any) => {
        this.logService.error({
          message: 'Error on save notifications info',
          error,
        })
        throw error.response
      })
  }
}
